import { Component } from '@angular/core';

import { TableRowComponent } from './table/table-row.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { NgClass, NgStyle, AsyncPipe, LowerCasePipe, DecimalPipe } from '@angular/common';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'app-disease-dashboard-widget-table-row',
    styleUrl: './widget.component.scss',
    template: `
    <div class="flex--row">
      <div class="flex__child--1 crop-field-cell">
        <mat-checkbox [checked]="isSelected$ | async" (change)="onSelectionChange($event.checked)"></mat-checkbox>
      </div>
      <div class="crop-field-cell flex__child--3 text--left">
        <span class="crop-field-name">{{ cropFieldName() }}</span>
        <span class="text--gray">{{ amountOfHectares() | number: '1.2' }} {{ 'hectares' | translate | lowercase }}</span>
      </div>
      @for (advice of dailyAdvices(); track advice.date) {
        <div
          class="advice-cell flex__child--2 text--center"
          [ngClass]="getClasses(advice)"
          [ngStyle]="getAdviceSpecificStyling(advice)">
          <span>{{ getAdviceText(advice) | translate }}</span>
        </div>
      }
    </div>
  `,
    imports: [
        MatCheckbox,
        NgClass,
        NgStyle,
        AsyncPipe,
        LowerCasePipe,
        DecimalPipe,
        TranslatePipe,
    ],
})
export class DiseaseDashboardWidgetTableRowComponent extends TableRowComponent { }
